// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1OUky","addWidgetButton":"Header_addWidgetButton__2Tpk_","dashboardTabs":"Header_dashboardTabs__35MaT","active":"Header_active__hmr4r"};